import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { delay } from 'rxjs';

import { EcmDispatcherModule } from '@ecm/dispatcher';
import { TitleService } from '@ecm/router';

import { MenuStoreService } from '../../store/menu-store.service';

@Component({
    selector: 'ecm-orange-menu',
    templateUrl: 'orange-menu.html',
    styleUrls: ['orange-menu.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgTemplateOutlet, RouterLink, AsyncPipe, TranslateModule],
})
export class OrangeMenuComponent implements OnInit, OnDestroy {
    private readonly _menuStore = inject(MenuStoreService);
    private readonly _titleSvc = inject(TitleService);

    public showBack$ = this._menuStore.showBack$.pipe(delay(0));
    public title$ = this._titleSvc.getTitle().pipe(delay(0));

    public ngOnInit(): void {
        this._menuStore.enter();
    }

    public ngOnDestroy(): void {
        this._menuStore.leave();
    }

    public navigateToBackRoute(): void {
        this._menuStore.navigateToBackRoute();
        EcmDispatcherModule.sendBackRoute(null);
    }
}
